<form class="form" [formGroup]="form">
  <div class="vox-input-group vox-input-group_dense"
    [ngClass]="{'vox-input-group_invalid': form.controls.brand?.invalid && (form.controls.brand?.dirty || form.controls.brand?.touched)}">
    <label for="brand" class="vox-label" translate>connectivity.entry-form.brand</label>
    <input class="vox-text-field" formControlName="brand" id="brand" type="text" [placeholder]="'connectivity.entry-form.brand' | translate">
    <span class="vox-input-group__error-message" translate>connectivity.errors.required</span>
  </div>
  <div class="vox-input-group vox-input-group_dense"
    [ngClass]="{'vox-input-group_invalid': form.controls.model?.invalid && (form.controls.model?.dirty || form.controls.model?.touched)}">
    <label for="model" class="vox-label" translate>connectivity.entry-form.model</label>
    <input class="vox-text-field" formControlName="model" id="model" type="text" [placeholder]="'connectivity.entry-form.model' | translate">
    <span class="vox-input-group__error-message" translate>connectivity.errors.required</span>
  </div>
  <div class="vox-input-group vox-input-group_dense">
    <label for="type" class="vox-label" translate>connectivity.entry-form.type</label>
    <div class="vox-dropdown-input" ngbDropdown>
      <button ngbDropdownToggle>{{'connectivity.equipment-type.' + form.controls.type.value | lowercase | translate}}</button>
      <div ngbDropdownMenu>
        <button ngbDropdownItem *ngFor="let type of entryTypes" (click)="onSelectType(type)">{{'connectivity.equipment-type.' + type | lowercase | translate}}</button>
      </div>
    </div>
  </div>
</form>